import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../../base-template-editor/template-editor.component';
import { RequiredFieldConstraint } from '../../../../../models/template/required-field-constraint.interface';

@Component({
    selector: 'app-meta-video-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/meta-video-template/"
      channelLabel="Meta Video Ad"
      namePlaceholder="Enter Meta Video Ad template name"
      emptyMessage="No Meta Video Ad found!"
      heartbeatType="meta-video-template"
      [showSidePreview]="true"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks"
      [requiredFields]="requiredFields"
      />
  `
})
export class MetaVideoTemplateComponent {
  protected readonly templateType = TypeEnum.META_VIDEO;

  // Video upload and the dropdowns render no text editor, so the empty-field
  // check on save cannot see them — they are required explicitly.
  protected readonly requiredFields: RequiredFieldConstraint[] = [
    { blockName: 'meta-video-cta-text', field: 'Text', label: 'CTA' },
    { blockName: 'meta-video-account-type', field: 'AccountType', label: 'Account type' },
    { blockName: 'meta-video-video', field: 'Video', label: 'Video' },
  ];

  // Order matters — it is the order the blocks are laid out in the editor.
  protected readonly defaultBlocks: { name: string; count?: number; variables: Record<string, string> }[] = [
    { name: 'meta-video-headline', count: 1, variables: { MetaVideoHeadline_1: '' } },
    { name: 'meta-video-primary-text', count: 1, variables: { MetaVideoPrimaryText_1: '' } },
    { name: 'meta-video-cta-text', count: 1, variables: { Text: '' } },
    { name: 'meta-video-url', count: 1, variables: { Link: '' } },
    { name: 'meta-video-account-type', count: 1, variables: { AccountType: '' } },
    { name: 'meta-video-video', count: 1, variables: { Video: '' } },
  ];
}
